import { getIn, useField, useFormikContext } from "formik"
import { FormikSelect, FormikSwitch, FormikTextInput } from "../../../../../../components/widgets";
import { IDLMROIEditItemModel } from "./_models";

import { KTSVG } from "../../../../../../../_metronic/helpers";
import { isPopulatedArray } from "../../../../../../components/helpers";
import { cloneDeep, map } from "lodash";
import { Fragment, useEffect, useMemo, useRef } from "react";
import { LEAF_TYPE_OPTIONS } from "../../../_constants";

export const DLMROIEditModalDetailsTable = () => {

  
  const { values, setFieldValue, setFieldTouched } = useFormikContext();

  const { isDoor } = values as any;
  const [ , meta, helpers] = useField('details');
 
  const { value: details, touched } = meta;
  const { setValue } = helpers;

  const rowValues = useMemo(() => {
    let _values = [];
    for (const items of Object.values(details)) {      
      _values.push(
        map(items as Array<IDLMROIEditItemModel>, 'quantity')
      )
    }  
    return _values;
  }, [details])

  const timerRef = useRef<any>();

  const clearTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = undefined
    }
  }

  const revalidateQuantity = () => {
    clearTimer();

    timerRef.current = setTimeout(() => {
      let _changed = false;
      let _details = cloneDeep(details);

      if (! _details) return;
      
      // eslint-disable-next-line 
      for (const [key, items] of Object.entries(_details)) {        
        let _rowChanged = false;
        let _itemset: Array<IDLMROIEditItemModel> = [];        
        let remaining = 0;
        // eslint-disable-next-line 
        (items as Array<IDLMROIEditItemModel>).forEach((row: IDLMROIEditItemModel, idx: number) => {
          
          const _row = {...row};
          if (idx === 0) {        
            remaining = parseInt(`0${row.originalQty}`);
            _itemset.push(_row);
            return;
          }
          const _quantity = parseInt(`0${row.quantity}`);
          let _get = Math.min(remaining, _quantity);          
          remaining -= _get;
          
          if (`${_get}` !== `${row.quantity}`) {
            Object.assign(_row, { quantity: _get});
            _rowChanged = true;                    
            setFieldTouched(`details.${key}.${idx}.quantity`, true, true);      
          }
          _itemset.push(_row);
        })              

        if (`${remaining}` !== `${_itemset[0].quantity}`) {
          // update first value as
          Object.assign( _itemset[0], {quantity : remaining});          
          _rowChanged = true;
          setFieldTouched(`details.${key}.0.quantity`, true, true);    
        }

        if (_rowChanged) {
          Object.assign(_details, {[key]: _itemset});
          _changed = true;
        }
      }

      // update details if needed
      if (_changed) {
        setValue(_details);
      }
    }, 1200);
  }


  const copyItem = (key: string) => {
    let _itemset = details[key];
    if (! (_itemset && isPopulatedArray(_itemset))) {
      return;
    }

    _itemset.push({
      ...(_itemset[0] ?? {}),
      quantity: 1
    });

    setFieldValue(`details.${key}`, _itemset);
    revalidateQuantity();
  }

  const removeItem = (key: string, idx: number) => {
    let _itemset = details[key];
    if (! (_itemset && _itemset.length > 1 && idx < _itemset.length)) {
      return;
    }

    _itemset.splice(idx, 1);
    setFieldValue(`details.${key}`, _itemset);
    revalidateQuantity();
  }

  const parseDoorSize = (e: any) => {
    const elem = e.target.closest('.itemRow');
    if (!(elem && elem?.dataset)) return;
    
    const prefix = elem.dataset.prefix;
    const _itemSize = `${prefix}.size`;
    const F = e.target.name.match(/sizeF$/) ? e.target.value : getIn(values, `${_itemSize}F`);
    const L = e.target.name.match(/sizeL$/) ? e.target.value : getIn(values, `${_itemSize}L`);        
    setFieldValue(_itemSize,`${F ? F : ''}(F) ${L ? L : ''}(L)`);
  }

  useEffect(() => {    
    revalidateQuantity();
    // eslint-disable-next-line
  }, [touched, rowValues])

  useEffect(() => {
    clearTimer();
    timerRef.current = setTimeout(() => {
      setFieldTouched('bpNumber',true,true)
    }, 800);
    return () => {
      clearTimer();
    }
    // eslint-disable-next-line
  },[]);

  if (! (details)) {
    return null;
  }

  return (
  <>
  <div className='fw-bold fs-7 mt-4'>
    Item Details
  </div>
  <div className='separator border-gray-200 my-0'></div>
  <div className='table-responsive min-h-80px mh-150px mb-4'>
    <table
      id='kt_table_roiedit_items'
      className='table align-middle table-row-bordered table-row-gray-300 fs-7 gy-2 dataTable no-footer'
    >
      <thead>
        <tr className='text-start text-muted fw-bolder fs-7 text-uppercase gs-0'>
          <th className="p-2">No</th>
          <th className="p-2">Series</th>
          <th className="p-2">Quantity</th>          
          <th className="p-2">Size W x H  (mm) / Model</th>
          { isDoor &&
          <>
          <th className="p-2 required">Leaf Type</th>
          <th className="p-2 required">Vision Panel</th>
          </>
          }
          <th className="p-2">Remarks</th>
          <th></th>
        </tr>
      </thead>
      <tbody className='text-gray-800 align-middle fs-6'>
      { Object.entries(details).map((tvals, tidx) => (
        <Fragment key={`targetRows-${tidx}-${tvals[0]}}`}>
        { // @ts-ignore
        [...Array(tvals[1].length)].map((_ , idx) => (
        <tr key={`itemDetail_${tvals[0]}_${idx}`} className="itemRow" data-idx={idx} data-prefix={`details.${tvals[0]}.${idx}`} >
          <td className="p-2 align-top">
            <FormikTextInput size={12} name={`details.${tvals[0]}.${idx}.itemNo`} addClass={'w-50px text-center'} readOnly />
          </td>
          <td className="p-2 align-top">
            <div className="p-0 m-0 d-flex flex-wrap w-150px">
            <FormikTextInput size={'6 px-0'} name={`details.${tvals[0]}.${idx}.labelFrom`} addClass={'w-70px px-1'} readOnly />
            <FormikTextInput size={'6 px-0'} name={`details.${tvals[0]}.${idx}.labelTo`} addClass={'w-70px px-1'} readOnly />
            </div>
          </td>
          <td className="p-2 align-top">
            <FormikTextInput size={12} name={`details.${tvals[0]}.${idx}.quantity`} addClass={'w-60px text-center'} readOnly={idx === 0}/>
          </td>
          <td className="p-2 align-top">
            { isDoor ? (
            <>
            <div className="row align-items-top w-250px">
              <FormikTextInput
                size={'5 pe-0'}
                name={`details.${tvals[0]}.${idx}.sizeF`}
                onChange={parseDoorSize}
                addClass="fs-7"
                placeholder="W x H"
              />
              <div className="col-1 ps-0 fw-bold fs-7">(F)</div>
              <FormikTextInput
                size={'5'}
                name={`details.${tvals[0]}.${idx}.sizeL`}
                onChange={parseDoorSize}
                addClass="fs-7"
                placeholder="W x H"
              />
              <div className="col-1 ps-0 fw-bold fs-7">(L)</div>                                
            </div>
            </>
            ) : (
            <FormikTextInput
              size={12}
              name={`details.${tvals[0]}.${idx}.size`}
              addClass={'w-175px'}
              placeholder="W x H"
            />
            )}            
          </td>
          { isDoor &&
          <>
          <td className="p-2 align-top min-w-100px">
            <FormikSelect
              size={12}
              name={`details.${tvals[0]}.${idx}.doorType`}                                
              options={LEAF_TYPE_OPTIONS}
            />
          </td>
          <td className="p-2 align-top text-center">
            <FormikSwitch
              size={'12'}
              name={`details.${tvals[0]}.${idx}.visionPanel`}
            />
          </td>
          </>
          }
          <td className="p-2 align-top">
            <FormikTextInput size={12} name={`details.${tvals[0]}.${idx}.remarks`} addClass={'min-w-125px'} />
          </td>
          <td>
            <div className="mt-n1 ms-n1">
            { (idx === 0 && getIn(values, `details.${tvals[0]}.${idx}.quantity`) > 1) &&
            <button
              type="button"
              className="btn btn-icon btn-sm p-0 h-15px w-15px text-hover-success"
              onClick={() => {
                copyItem(tvals[0]);
              }}
              title="Add"
            >
              <KTSVG path='/media/icons/duotune/general/gen035.svg' className='svg-icon-0 m-0' />
            </button>
            }
            { (idx > 0) &&
            <button
              type="button"
              className="btn btn-icon btn-sm p-0 h-15px w-15px text-hover-danger"
              onClick={() => {
                removeItem(tvals[0], idx);
              }}
              title="Delete"
            >
              <KTSVG path='/media/icons/duotune/general/gen034.svg' className='svg-icon-0 m-0' />
            </button>
            }
            </div>
          </td>
        </tr>
        ))
        }
        </Fragment>
      ))}
      </tbody>
    </table>
  </div>
  </>
  )
}